import { Signal } from '../utils/signals'
import { createFeatureFlags } from './flags-impl'

export type FeatureFlagValues = {
  singleLogin: boolean
  localMode: boolean
}

/** Env keys which decide the default value of the flags */
export const featureFlagEnvKeys: Record<keyof FeatureFlagValues, string> = {
  singleLogin: "REACT_APP_SINGLE_LOGIN_PREVIEW",
  localMode: "REACT_APP_LOCAL_MODE"
}

export type FeatureFlags = {
  values: FeatureFlagValues
  changeSignal: Signal<FeatureFlagValues>
}

export const allFeatureFlags = Object.keys(featureFlagEnvKeys) as (keyof FeatureFlagValues)[]

declare global {
  interface Window {
    featureFlags: FeatureFlags
  }
}
export const featureFlags = createFeatureFlags()

export { useFeatureFlags } from './flags-impl'

window.featureFlags = featureFlags
